// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../assets/stylesheets/variables.scss\"","smallWidth":"768px","button":"CopyEmbedButton_button__3pKkx"};